"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var wrapComponent = function () { return function (WrappedComponent) {
    return (function (_super) {
        __extends(Hoc, _super);
        function Hoc(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                name: _this.props.name,
                value: _this.props.value,
                rows: _this.props.rows ? _this.props.rows : 1
            };
            _this.handleChange = _this.handleChange.bind(_this);
            _this.handleBlur = _this.handleBlur.bind(_this);
            return _this;
        }
        Hoc.prototype.handleChange = function (event) {
            var newValue = event.target.value;
            this.setState({ value: newValue });
            this.props.onChange({ name: this.state.name, value: newValue });
        };
        Hoc.prototype.handleBlur = function () {
            var nValue = this.state.value;
            this.setState({
                value: nValue
            });
            if (typeof this.props.onBlur !== 'undefined') {
                this.props.onBlur({ name: this.state.name, value: nValue });
            }
        };
        Hoc.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            this.setState({ value: nextProps.value });
        };
        Hoc.prototype.render = function () {
            return (react_1["default"].createElement(WrappedComponent, { value: this.state.value, onChange: this.handleChange, onBlur: this.handleBlur, rows: this.state.rows, cols: this.props.cols, placeholder: this.props.placeholder, disabled: this.props.disabled }));
        };
        return Hoc;
    }(react_1["default"].Component));
}; };
exports["default"] = wrapComponent;
